module.exports = __webpack_public_path__ + "pc-top-assets/img/info-card.d4f5640b.png";